module.exports = __webpack_public_path__ + "img/store-info.56f55da1.svg";